<template>
  <v-dialog :value="value" width="1000" persistent>
    <v-card>
      <v-card-title>Change Tariff</v-card-title>

      <v-card-text>
        <div class="d-flex justify-start">

          <div class="section pr-8 section__stepper">
            
            <v-stepper v-model="getCurrentStep" vertical>

              <ChangeReasonSection :step="1" />

              <template v-if="getProductKind==='telco'">
                <template v-if="getChangeReason.value==='CHANGE_ADDON'">
                  <AddonsSection :step="2" />
                  <LineFeaturesSection :step="3" />
                  <AdhocChargesSection :step="4" />
                  <ConfirmChangesSection :step="5" />
                </template>

                <template v-else>
                  <TariffSection :step="2" />
                  <AddonsSection :step="3" />
                  <LineFeaturesSection :step="4" />
                  <AdhocChargesSection :step="5" />
                  <ConfirmChangesSection :step="6" />
                </template>
              </template>

            </v-stepper>

          </div>

          <v-divider class="vertDivider" vertical />

          <div class="section section__view pl-8">

            <div class="section__changes">

              <ChangeReasonView :step="1" />

              <template v-if="getProductKind==='telco'">
                <template v-if="getChangeReason.value==='CHANGE_ADDON'">
                  <AddonsView :step="2" />
                  <LineFeaturesView :step="3" />
                  <AdhocChargesView :step="4" />
                </template>

                <template v-else>
                  <TariffView :step="2" />
                  <AddonsView :step="3" />
                  <LineFeaturesView :step="4" />
                  <AdhocChargesView :step="5" />
                </template>
              </template>

            </div>

            <div class="section__prices">
              <template v-if="getCurrentStep>2 || (getCurrentStep>1 && getChangeReason.value==='CHANGE_ADDON')">
                <template v-for="(item,index) in getTotals">
                  <div :key="index" class="d-flex justify-space-between">
                    <div>{{item.name}}</div>
                    <div class="font-weight-bold">{{item.total | formatCurrency}}</div>
                  </div>
                </template>
              </template>
            </div>

          </div>

        </div>
      </v-card-text>

      <v-divider />
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="primary" class="action_buttons" small @click="submit" :disabled="!getSection('confirm')||getChangeTariffLoading" :loading="getChangeTariffLoading">CHANGE TARIFF</v-btn>
        <v-btn color="primary" class="action_buttons" small outlined @click="close">CLOSE</v-btn>

      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {mapActions, mapGetters, mapMutations} from 'vuex';

  import ChangeReasonSection from './Sections/all/ChangeReason';
  import TariffSection from './Sections/all/Tariff';
  import AddonsSection from './Sections/all/Addons';
  
  import LineFeaturesSection from './Sections/telco/LineFeatures';
  import AdhocChargesSection from './Sections/telco/AdhocCharges';
  import ConfirmChangesSection from './Sections/telco/ConfirmChanges';

  import ChangeReasonView from './ChangedSections/all/ChangeReason';
  import TariffView from './ChangedSections/all/Tariff';
  import AddonsView from './ChangedSections/all/Addons';
  
  import LineFeaturesView from './ChangedSections/telco/LineFeatures';
  import AdhocChargesView from './ChangedSections/telco/AdhocCharges';

  export default {

    props: ['value'],

    components: { 
      ChangeReasonSection,TariffSection,AddonsSection,LineFeaturesSection,AdhocChargesSection,ConfirmChangesSection,
      ChangeReasonView,TariffView,AddonsView,LineFeaturesView,AdhocChargesView
    },

    computed: {
      ...mapGetters('changeTariff',['getAllSections','getTotals','getCurrentStep','getProductKind','getChangeReason','getSection','getChangeTariffLoading','getChangeTariffError']),
      ...mapGetters('products',['getCurrentProduct']),
    },

    methods: {
      ...mapActions('changeTariff',['postChangeTariff']),
      ...mapMutations('changeTariff',['reset_changeTariff']),

      async submit() {
        await this.postChangeTariff(this.getAllSections(this.getCurrentProduct));
        if(!this.getChangeTariffError){
          this.close();
          setTimeout(window.location.reload(),250);
        }
      },

      close() {
        this.reset_changeTariff();
        this.$emit('input', false);
      },
    },

  }
</script>

<style lang="scss" scoped>

  ::v-deep {
    .narrowInputs { width: 300px; }
    // .v-btn.action_buttons { margin: 0; }
  }

  .section__stepper {
    width: 62%;
    height: 430px;
    overflow: hidden;
    overflow-y: auto;
  }

  .section__view {
    width: 38%;
  }

  .section__changes {
    height: 300px;
    overflow: hidden;
    overflow-y: auto;
  }

  .section__prices {
    padding-top: 10px;
    height: 130px;
  }

  .v-stepper {
    padding-right: 36px;
    box-shadow: none;

    ::v-deep {
      .v-stepper__step {
        padding: 0;
        margin: 24px 24px 16px 0;
      }

      .v-stepper__content {
        padding: 0;
      }

      .v-stepper__step--active ~ .v-stepper__content:not(.complete) .v-stepper__wrapper {
        height: auto !important;
        padding: 4px 0;
      }
    }
  }

  @media only screen and (min-height: 768px) {

    .section__stepper {
      height: 530px;
    }

    .section__changes {
      height: 400px;
    }
  }

</style>
